import {
  doublePrecision,
  foreignKey,
  integer,
  pgTable,
  primaryKey,
  uuid,
  text,
} from "drizzle-orm/pg-core";
import type { Barcode } from "@corpuscomplete/core/common/barcode";
import { food, foodMeta, foodServing } from "../food/food.sql";
import { nutrient } from "../nutrient/nutrient.sql";
import { relations } from "drizzle-orm";

export const brandedFood = pgTable(
  "branded_food",
  {
    id: uuid("id").notNull(),
    version: integer("version").notNull(),
    code: text("code").$type<Barcode.Canonical>(),
    brandName: text("brand_name").notNull(),
    productName: text("product_name").notNull(),
  },
  (t) => [
    primaryKey({ name: "branded_food_pk", columns: [t.id, t.version] }),
    foreignKey({
      name: "branded_food_food_fk",
      columns: [t.id, t.version],
      foreignColumns: [food.id, food.version],
    }),
  ],
);

export const brandedFoodRelations = relations(brandedFood, ({ one }) => ({
  base: one(food, {
    fields: [brandedFood.id, brandedFood.version],
    references: [food.id, food.version],
  }),
  meta: one(foodMeta, {
    fields: [brandedFood.id],
    references: [foodMeta.id],
  }),
  metaIfCurrent: one(foodMeta, {
    fields: [brandedFood.id, brandedFood.version],
    references: [foodMeta.id, foodMeta.currentVersion],
  }),
}));

export const brandedFoodServingNutrient = pgTable(
  "branded_food_serving_nutrient",
  {
    foodId: uuid("food_id").notNull(),
    foodVersion: integer("food_version").notNull(),
    foodServingId: uuid("food_serving_id").notNull(),
    nutrientId: uuid("nutrient_id")
      .references(() => nutrient.id)
      .notNull(),
    amount: doublePrecision("amount").notNull(),
  },
  (t) => [
    primaryKey({
      name: "branded_food_serving_nutrient_pk",
      columns: [t.foodServingId, t.nutrientId],
    }),
    foreignKey({
      name: "branded_food_serving_nutrient_serving_fk",
      columns: [t.foodId, t.foodServingId],
      foreignColumns: [foodServing.foodId, foodServing.id],
    }),
    foreignKey({
      name: "branded_food_serving_nutrient_food_fk",
      columns: [t.foodId, t.foodVersion],
      foreignColumns: [brandedFood.id, brandedFood.version],
    }),
  ],
);
